import {
  clearTimeouts,
  engine as anime,
} from "../../../../../animations/index";
import { getTemplateDurationOveride } from "../../../../shared/utils/timeline";

const timeouts = [];

const main = (props) => {
  const timeouts = [];
  const { id } = props;

  const timeline = anime.timeline({
    autoplay: false,
  });
  anime({
    targets: [`#${id} .subheadline`, `#${id} .header-v1`],
    duration: 1000,
    easing: "easeOutQuint",
    scale: [0, 1],
    delay: 1000,
    complete: () => {
      anime.timeline({
        targets: [`#${id} .subheadline`, `#${id} .header-v1`],
        easing: 'easeInOutSine',
        loop: 8,
        complete: () => {
          anime({
            targets: [`#${id} .subheadline`, `#${id} .header-v1`],
            duration: 300,
            easing: "easeOutQuint",
            translateY: [0, -700],
            delay: 200,
          })
          anime({
            targets: [`#${id} .center-block-side .team-logo-container`],
            duration: 800,
            translateY: [1000, 0],
            easing: "easeOutQuint",
            delay: 500,
            complete: () => {
              anime({
                targets: [`#${id} .center-block-side .team-logo-container`],
                duration: 800,
                translateX: [0, -500],
                easing: "easeOutQuint",
                delay: 10,
              });
            }
          });
          anime({
            targets: [`#${id} .player-wrap`],
            duration: 800,
            bottom: 170,
            easing: "easeOutQuint",
            delay: 500,
            complete: () => {
              anime({
                targets: [`#${id} .comp-match-score-widget`],
                duration: 800,
                easing: "easeOutQuint",
                translateY: [-1000, 0],
                delay: 10,
                complete: () => {
                  anime({
                    targets: [`#${id} .match-time-wrapper`],
                    duration: 1000,
                    easing: "easeOutQuint",
                    scale: [0, 1],
                    delay: 10,
                  });
                }
              });
              anime({
                targets: [`#${id} .player-wrap`],
                duration: 800,
                scale: [2, 1],
                bottom: 0,
                left: -210,
                easing: "easeOutQuint",
                delay: 10,
                complete: () => {
                }
              })
            }
          })
          // 
        }
      })
        .add({
          translateX: [-10, 10],
          duration: 50,
          color: ['#ffffff', '#ffff00'], // white ↔ yellow
          direction: 'alternate',
        })
        .add({
          translateY: [-10, 10],
          color: ['#ffff00', '#ffffff'], // yellow ↔ white
          duration: 50,
          direction: 'alternate',
        });
    }
  });

  return {
    timeline,
    timeouts,
  };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
  const { timeouts } = animationReturn;
  clearTimeouts(timeouts);
};

export default main;
